import * as actions from "../constants/orderConstants";
import * as cartActions from "../constants/cartConstants";
import axios from "axios";
import { logout } from "./userActions";


// CREATE ORDER
export const createOrder = (dataOrder, isDirectPurchase = false) => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.ORDER_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/orders`, dataOrder, config);

    dispatch({ type: actions.ORDER_CREATE_SUCCESS, payload: data.order });

    // Conditionally clear cart only if order placed from cart (not direct purchase)
    if (!isDirectPurchase) {
      dispatch({ type: cartActions.CART_CLEAR_ITEMS });
      localStorage.removeItem("cartItems");
    }

  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    if (message === "not authorized, no token") {
      dispatch(logout());
    }

    dispatch({
      type: actions.ORDER_CREATE_FAILED,
      payload: message,
    });
  }
};



// GET ORDER DETAILS
export const getOrderDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.ORDER_DETAILS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/orders/${id}`, config);

    dispatch({ type: actions.ORDER_DETAILS_SUCCESS, payload: data.order });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    if (message === "not authorized, no token") {
      dispatch(logout());
    }

    dispatch({
      type: actions.ORDER_DETAILS_FAILED,
      payload: message,
    });
  }
};

// PAY ORDER
export const payOrder =
  (orderId, paymentResult) => async (dispatch, getState) => {
    try {
      dispatch({ type: actions.ORDER_PAY_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/orders/${orderId}/pay`,
        paymentResult,
        config
      );

      dispatch({ type: actions.ORDER_PAY_SUCCESS, payload: data.order });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      if (message === "not authorized, no token") {
        dispatch(logout());
      }

      dispatch({
        type: actions.ORDER_PAY_FAILED,
        payload: message,
      });
    }
  };

// DELIVER ORDER
export const deliverOrder = (orderId) => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.ORDER_DELIVER_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/orders/${orderId}/deliver`, {}, config);

    dispatch({ type: actions.ORDER_DELIVER_SUCCESS });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    if (message === "not authorized, no token") {
      dispatch(logout());
    }

    dispatch({
      type: actions.ORDER_DELIVER_FAILED,
      payload: message,
    });
  }
};

// LIST USER ORDERS
export const listMyOrders = () => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.ORDER_LIST_MY_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/orders/myorders`, config);

    dispatch({ type: actions.ORDER_LIST_MY_SUCCESS, payload: data.orders });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    if (message === "not authorized, no token") {
      dispatch(logout());
    }

    dispatch({
      type: actions.ORDER_LIST_MY_FAILED,
      payload: message,
    });
  }
};

// LIST ALL ORDERS (ADMIN)
export const listOrders = () => async (dispatch, getState) => {
  try {
    dispatch({ type: actions.ORDER_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/orders/`, config);

    dispatch({ type: actions.ORDER_LIST_SUCCESS, payload: data.orders });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    if (message === "not authorized, no token") {
      dispatch(logout());
    }

    dispatch({
      type: actions.ORDER_LIST_FAILED,
      payload: message,
    });
  }
};
